export default {
  youtube: {
    embedTemplate: 'https://www.youtube.com/embed/',
    imgPathStart: 'https://img.youtube.com/vi/',
    imgPathEnd: '/hqdefault.jpg'
  }
};
